<template>
    <div>
        <h2>这是关于</h2>
    </div>
</template>

<script>
export default {
    name: 'About',
    data() {
        return{

        }
    },
}
</script>

<style>
    
</style>